import { createFileRoute } from "@tanstack/react-router";
import { NotificationSettings } from "@/features/settings/preferences";

export const Route = createFileRoute("/_app/settings/notifications")({
  head: () => ({ meta: [{ title: "Notifications · Settings · Malfak" }] }),
  component: NotificationSettings,
});
